import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CommonService } from './common.service';
import { UserInfoService } from './user-info.service';
import { AemService } from './aem.service';
import { Observable } from 'rxjs';
import { ProductRecommendationRequestV2, ProductRecommendationResponse } from '../models/endpoints/p13n-endpoint.model';
@Injectable({
	providedIn: 'root'
})

export class P13nEndpointService {
	constructor(
		private _http: HttpClient,
		private _commonService: CommonService,
		private _userInfoService: UserInfoService,
		private _aemService: AemService,
	) { 
	}

	public getP13nProductsRecommendation(payload: ProductRecommendationRequestV2): Observable<ProductRecommendationResponse> {
		const httpOptions = this.generateProductRecommendationsRequestOptions();

		let url = window.location.origin + window['SWY']['CONFIGSERVICE'].wcaxXapiConfig['p13n.genericCarousel.basePath'];
		url += (url.includes('?') ? '&' : '?') + `includeOffer=true`;
		return this._http.post<ProductRecommendationResponse>(url, payload, httpOptions);
	}

	// Generates dynamic fields for the p13n request payload
	public generateProductsRequestPayload(dynamicFields: ProductRecommendationRequestV2): ProductRecommendationRequestV2 {
		const payload: ProductRecommendationRequestV2 = {
			...dynamicFields,
			bruid: this._aemService.getCookie('_br_uid_2'),
			assortmentChannel: dynamicFields?.assortmentChannel ?? this._userInfoService.getUserChannel(),
			banner: dynamicFields?.banner ?? this._userInfoService.getBanner(),
			storeId: dynamicFields?.storeId ?? this._userInfoService.getShopStoreId(),
			host: dynamicFields?.host ??  'www.' + this._userInfoService.getBanner()+ '.com',
			pageURL: dynamicFields.pageURL ?? 'https://www.' + this._userInfoService.getBanner() + '.com' + window.location.pathname
		}

		if (this._commonService.checkAnalyticsSwyObject()) {
			const adobeIds = window['analyticsSwy'].storedData.ids;

			payload['sessionId'] = adobeIds.sessionId ? adobeIds.sessionId : '';
			payload['tntId'] = adobeIds.tntId ? adobeIds.tntId : '';
			payload['marketingCloudVisitorId'] = adobeIds.marketingCloudVisitorId ? adobeIds.marketingCloudVisitorId : '';
			payload['mboxMCSDID'] = adobeIds.mboxMCSDID ? adobeIds.mboxMCSDID : '';
			payload['edgeHost'] = adobeIds.edgeHost ? adobeIds.edgeHost : '';
		}

		// check to add cartItems to payload
        let cartItemsArr = []
        if (this._aemService.authorize()
            && !window['SWY']?.['CONFIGSERVICE']?.featureToggleConfig?.isBPNArrayP13nDisabled) {
                cartItemsArr = this.getProductBPNFromCartObj();
                if (cartItemsArr.length > 0) {
                    payload.cartItems = cartItemsArr;  
                }
        }

		return payload;
	}
	public addAmvcCookieInfo(payload: ProductRecommendationRequestV2): void {
		if (!payload?.marketingCloudVisitorId) {
			// check AMVC cookie for adobe value - for when adobe analyticsSwy is not loaded yet
			const adobeCookie_AMVC = this._aemService.getCookie('AMCV_A7BF3BC75245ADF20A490D4D@AdobeOrg');

			if (adobeCookie_AMVC) {
				const cookie_MCMID = adobeCookie_AMVC.split('|');
				if (cookie_MCMID && cookie_MCMID?.indexOf('MCMID') > 0) {
					payload.marketingCloudVisitorId = cookie_MCMID[cookie_MCMID?.indexOf('MCMID') + 1];
				}
			}
		}
	}

	private generateProductRecommendationsRequestOptions() {
		const httpOptions = {
			headers: new HttpHeaders({
				'Content-Type': 'application/vnd.safeway.v2+json',
				'Ocp-Apim-Subscription-Key': window['SWY']['CONFIGSERVICE'].searchConfig['apimP13nSubscriptionKey'],
				'platform': 'web'
			})
		};

		if (this._aemService.authorize()) {
			httpOptions.headers = httpOptions.headers.set('X-access-token', window['AB']['userInfo']['SWY_SHOP_TOKEN']);
		}

		// check if on B2B site - pass http header "pgm" = "1P_B2B"
		if (window['AB']?.COMMON.isB2BSite()) {
			httpOptions.headers = httpOptions.headers.set('pgm', '1P_B2B');
		}
		return httpOptions;
	}

	// get cartitems
    public getProductBPNFromCartObj() {
        const abCartString= localStorage.getItem('abCart');
        const bpnListFromCartObj = [];
        if (abCartString) {
            const abCartObj = JSON.parse(abCartString);
            if( abCartObj['cartItems']?.length > 0 && abCartObj.cartSource == 'ABS' 
                && abCartObj.cartCategory == '1P' ) {
                        abCartObj['cartItems'].forEach(item => {
                            if (item['itemId']) {
                                const itemObj = { 'bpn' : item['itemId'].toString() };
                                bpnListFromCartObj.push(itemObj);
                            }
                        });
            }
        }
        return bpnListFromCartObj
    }
}
